import { Tooltip } from "PFComponents/tooltip";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking } from "PFTypes";

import { useNotApplicable } from "../hooks/use_not_applicable";

const DENSE_MODE_MAX_LENGTH = 18;
const WIDE_MODE_MAX_LENGTH = 50;

type TextColumnProps = {
  text: string;
  booking: Booking;
  isDense?: boolean;
};

export const TextColumn = ({ text, booking, isDense }: TextColumnProps) => {
  const { getCategory } = useBookingCategories();
  const NOT_APPLICABLE = useNotApplicable();
  const category = getCategory(booking);

  const maxLength = isDense ? DENSE_MODE_MAX_LENGTH : WIDE_MODE_MAX_LENGTH;
  const isTextTooLong = text.length > maxLength;
  const displayedText = isTextTooLong ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Tooltip content={isTextTooLong && category ? <span>{text}</span> : undefined}>
      {category ? displayedText : NOT_APPLICABLE}
    </Tooltip>
  );
};
